// base rc-steps 3.5.0
import Steps from './Steps';
import Step from './Step';

Steps.Step = Step;

export { Step };
export default Steps;
